import { createElement, FC } from 'react';

import { useAuthPageWrapperContext } from '../AuthPageWrapperContext';

interface FormTitleProps {
  titleLevel?: 1 | 2 | 3;
}

export const FormTitle: FC<FormTitleProps> = ({ titleLevel = 2, children }) => {
  const { cnBem } = useAuthPageWrapperContext();

  return createElement(
    `h${titleLevel}`,
    { className: cnBem('__formTitle') },
    children
  );
};
